import railwayRoutes from './routes'

/* @ngInject */
const run = (
  $transitions,
  storageHandler,
  $$railway,
  $$wagon,
  toaster
) => {
  $transitions.onSuccess({
    entering: railwayRoutes.new.path,
  }, (trans) => {
    if (storageHandler.get('consult.railway.new')) {
      $$railway.data.myRailway = storageHandler.get('consult.railway.new')
    } else {
      $$railway.data.myRailway = $$railway.new()
    }
  })

  $transitions.onBefore({
    from: railwayRoutes.new.path,
  }, (trans) => {
    if (!trans.to().redirectTo) {
      storageHandler.save('consult.railway.new', $$railway.data.myRailway)
      $$railway.data.myRailway = null
    }
  })

  $transitions.onSuccess({
    entering: railwayRoutes.home.path,
  }, async (trans) => {
    try {
      const response = await $$railway.request.getAll()
      $$railway.data.myRailways = response.railways
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: railwayRoutes.home.path,
  }, async (trans) => {
    $$railway.data.myRailways = null
  })

  $transitions.onSuccess({
    entering: railwayRoutes.details.path,
  }, async (trans) => {
    const railwayId = await $$railway.local.getCurrentId()

    try {
      if (!$$railway.data.myRailway || $$railway.data.myRailway.id !== railwayId) {
        $$railway.data.myRailway = await $$railway.request.getById(railwayId)
      }
      $$wagon.data.myWagons = await $$wagon.request.getByRailway(railwayId)
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: railwayRoutes.details.path,
  }, async (trans) => {
    $$railway.data.myRailway = null
    $$wagon.data.myWagons = null
  })

  $transitions.onSuccess({
    entering: railwayRoutes.edit.path,
  }, async (trans) => {
    const railwayId = await $$railway.local.getCurrentId()

    try {
      const railway = await $$railway.request.getById(railwayId)
      $$railway.data.myRailway = railway
      $$railway.data.myRailway.oldValue = railway.number
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: railwayRoutes.edit.path,
  }, async (trans) => {
    $$railway.data.myRailway = null
  })
}

export default run



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/railway/railway.run.js